import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { Config } from './config';

const poolData = {
    UserPoolId: Config.AUTH_POOL_ID,
    ClientId: Config.AUTH_CLIENT_ID
};


export default new CognitoUserPool(poolData);